// window._ = require('lodash');

window.Dio = require('./constants').default;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests to our Laravel
 * back-end. This library automatically handles sending the CSRF token as a header based on the
 * value of the "XSRF" token cookie.
 */

window.axios = require('axios');

const MOCK_SERVER = '';

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');
window.axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

window.axios.defaults.baseURL = `${MOCK_SERVER}/api/`;

/**
 * Echo exposes an expressive API for subscribing to channels and listening for events that are
 * broadcast by Laravel. Echo and event broadcasting allows your team to easily build robust
 * real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
